module.exports = __webpack_public_path__ + "media/src/images/favicon-32x32-135c164c77ee95828ce517a6fcc23419.png";